import { createIcon } from '../../createIcon';
import { withIcon } from '../../withIcon';
import { MenuSvg } from './Menu';

export const MenuIcon = createIcon('menu', MenuSvg);
/**
 * @deprecated используйте MenuIcon
 */
export const withMenuIcon = withIcon('menu', MenuSvg);
